window.pdfjsLib = window['pdfjs-dist/build/pdf'] = require('pdfjs-dist/build/pdf')
window.pdfjsWorker = window['pdfjs-dist/build/pdf.worker'] = require('pdfjs-dist/build/pdf.worker')

export const getPdfDocument = async ({ url }) => {
  const loadingTask = pdfjsLib.getDocument(url)
  const pdfDocument = await loadingTask.promise
  return pdfDocument
}

export const getVisiblePageRange = (viewportTop, viewportBottom, pagesMetadata) => {
  if (!pagesMetadata.length) return [0, 0]

  // 1. Find the first visible page using Binary Search
  let startIdx = 0
  let low = 0
  let high = pagesMetadata.length - 1

  while (low <= high) {
    const mid = Math.floor((low + high) / 2)
    // If the top of the page is above or at the viewport top, it's a candidate
    if (pagesMetadata[mid].top <= viewportTop) {
      startIdx = mid
      low = mid + 1
    } else {
      high = mid - 1
    }
  }

  // 2. Find the last visible page starting from the startIdx
  let endIdx = startIdx
  while (endIdx < pagesMetadata.length - 1 && pagesMetadata[endIdx].bottom < viewportBottom) {
    endIdx++
  }

  return [startIdx, endIdx]
}

export const getImageDimensions = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const dims = { url, width: img.naturalWidth, height: img.naturalHeight }

      // Cleanup — release memory asap
      img.onload = null
      img.onerror = null
      img.src = ''

      resolve(dims)
    }
    img.onerror = () => {
      resolve({ url, width: 1, height: 1 })
    }
    img.src = url
  })
}
